module.exports = Promise.resolve(module.bundle.root("2ql6X"))